/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';
// import { Link } from 'react-router-dom';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import object, {
    func, array, bool, string, shape,
} from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { emitCustomTrackingEvent } from '../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import generateValidCss from '../../../../helpers/contentstack/generateValidCss';
import { handleOnClick } from '../../utils/pathUtils';
import replaceSpecialChar from '../../../../helpers/replaceSpecialChar';
import { useDepartmentPageTracking, useIsDepartmentPageTrackingActive } from '../../../../helpers/tracking/page/DepartmentPageTrackingContext';

const styles = () => ({
    bot: {
        display: 'none',
    },
    link: {
        '&:hover': {
            opacity: '.9',
        },
    },
    hlist: {
        alignSelf: 'stretch',
        display: 'flex',
        '@media screen and (max-width: 1024px)': {
            padding: '5px !important',
        },
    },
    hlink: {
        padding: '8px 14px',
        cursor: 'pointer',
        width: 'auto',
        minWidth: '120px',
        maxWidth: '190px',
        alignItems: 'center',
        display: 'flex',
        '@media screen and (max-width: 1024px)': {
            padding: '5px !important',
        },
    },
    hcopy: {
        height: 'auto',
        width: '100%',
        textAlign: 'center',
    },
    vlink: {
        zIndex: '1',
        textAlign: 'left',
        cursor: 'pointer',
    },
    vlist: {
        display: 'block',
        width: '300px',
        margin: 'auto auto auto 0',
        textAlign: 'left',
        cursor: 'pointer',
    },
    divideTwoColumn: {
        columnCount: 2,
    },
    listLink: {
        display: 'block',
        cursor: 'pointer',
        padding: '2px 0px',
        textDecoration: 'none',
        border: '0px',
        fontSize: '16px',
        textIndent: '1em',
        fontWeight: '400',
        marginLeft: '0px',
        fontFamily: 'LatoRegular, Arial, Verdana, sans-serif',
    },
    lastLink: {
        borderBottom: '1px solid #ccc !important',
    },
    linkList: {
        fontFamily: 'latobold, Arial, Verdana, sans-serif',
        color: 'rgb(47, 47, 47)',
        zIndex: '1',
        width: 'fit-content',
        maxWidth: '400px',
        minWidth: '200px',
        textAlign: 'left',
        fontSize: '1.2em',
        boxSizing: 'border-box',
    },
});

function LinkListContainer(props) {
    const {
        data, history, classes, trackEvent, isBot, uid, type, departmentPageHeroRedesign, callCustomTrackingEvent,
    } = props;
    const trackDepartmentPage = useDepartmentPageTracking();
    const isDepartmentPageTrackingActive = useIsDepartmentPageTrackingActive();

    const trackFeatureClickEvent = (linking) => {
        if (isDepartmentPageTrackingActive) return;
        callCustomTrackingEvent({
            action: 'Click',
            eventSubType: 'feature-tracking',
            category: linking?.tracking_event_category || 'Browse',
            label: linking?.tracking_event_label || linking?.link?.title?.split(' ')?.join('-')?.toLowerCase() || '',
            link: linking?.link?.href || '',
            tag: linking?.tracking_event_action || '',
        });
    };

    if (type === 'footermenu') return null;

    const linkData = data?.link_list?.reference?.[0] || data?.reference?.[0] || data;
    if (!linkData) return null;

    const links = linkData.links;
    if (!links) return null;

    const listDivideTwoColumn =  linkData?.is_column_present || false;

    const renderAsButtons = linkData.presentation === 'Buttons';

    const getVerticalLinkStyle = (child, i, isLastParentBeforeChild, parentAfterChildIndices) => {
        const isLastParent = isLastParentBeforeChild?.includes(Number(i));
        const isLastChildParent = parentAfterChildIndices?.includes(Number(i));
        const linkStyle =  {};
        linkStyle.cursor = 'pointer';
        linkStyle.padding = '.1em .3em';
        linkStyle.textDecoration = 'none';
        linkStyle.border = '0';
        if (renderAsButtons) {
            linkStyle.fontSize = '1em';
            linkStyle.fontWeight = '400';
            if (i) {
                linkStyle.marginTop = '.5em';
            }
            return linkStyle;
        }
        if (!child) {
            linkStyle.fontSize =  '18px';
            linkStyle.fontWeight = '400';
            linkStyle.padding = isLastParent ? '16px 0px 0px' : '16px 0px';
            linkStyle.marginTop = isLastChildParent ? '16px' : '0px';
            if (i > 0 || departmentPageHeroRedesign) {
                linkStyle.borderTop = !listDivideTwoColumn && 'solid 1px #ccc';
            }
            linkStyle.marginLeft = '0';
        }
        return linkStyle;
    };

    const getTabIndex = (k) => parseInt(k, 10) + 1;

    const getLastParentIndicesBeforeChildren = (value) => {
        const indices = [];
        // eslint-disable-next-line no-plusplus
        for (let i = 1; i < value?.length; i++) {
            const prev = links?.[i - 1]?.link;
            const curr = links?.[i]?.link;
            if (prev?.is_child === false && curr?.is_child === true) {
                indices.push(i - 1);
            }
        }
        return indices;
    };
    const getFirstParentIndicesAfterChildren = (value) => {
        const indices = [];
        let insideChildBlock = false;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < value.length; i++) {
            const curr = value[i]?.link;
            if (curr?.is_child === true) {
                insideChildBlock = true;
            } else if (curr?.is_child === false && insideChildBlock) {
                indices.push(i);
                insideChildBlock = false;
            }
        }
        return indices;
    };
    const entries = Object.entries(links || {});
    const visibleEntries = entries.filter(([, value]) => value?.link && value?.link?.hide !== true);
    const lastVisibleKey = visibleEntries[visibleEntries.length - 1]?.[0];

    const lastParentIndices = getLastParentIndicesBeforeChildren(links);
    const parentAfterChildIndices = getFirstParentIndicesAfterChildren(links);
    return ( // Render Vertical Menus
        <div data-testid="divide-two-column" className={classes.linkList} tabIndex={getTabIndex(-1)} data-uniqueid={uid}>
            {linkData.heading && <h3>{linkData.heading}</h3>}
            {Object.entries(links).map(([key, value]) =>  value?.link && (
                <>
                    {isBot && (
                        <Link
                            className={classes.bot}
                            to={value?.link?.link?.href}
                            title={value?.link?.link?.title}
                        > {replaceSpecialChar(value?.link?.link?.title, true)}
                        </Link>
                    )}
                    {renderAsButtons ? (
                        <>
                            {!value?.link?.hide && (
                                <a
                                    href={value?.link?.link?.href}
                                    key={key}
                                    className={styles?.link}
                                    title={value?.link?.link?.title}
                                    data-ga-category={value?.link?.tracking_event_category || ''}
                                    data-ga-action={value?.link?.tracking_event_action || ''}
                                    data-ga-label={value?.link?.tracking_event_label || ''}
                                    onClick={() => {
                                        trackDepartmentPage(value?.link?.link?.title || 'LinkList');
                                        trackEvent({
                                            eventCategory: value?.link?.tracking_event_category || '',
                                            eventAction: value?.link?.tracking_event_action || '',
                                            eventLabel: value?.link?.tracking_event_label || '',
                                        });
                                        trackFeatureClickEvent(value?.link);
                                    }}
                                >
                                    {replaceSpecialChar(value?.link?.link?.title, true)}
                                </a>
                            )}
                        </>

                    )
                        : (
                            <>
                                {!value?.link?.hide && (
                                    <div
                                        key={key}
                                        role="button"
                                        to={value?.link?.link?.href}
                                        className={`${classes?.link} ${value?.link?.is_child ? classes.listLink : classes.parentLink} ${lastVisibleKey  === key ? classes.lastLink : ''}`}
                                        title={value?.link?.link?.title}
                                        style={getVerticalLinkStyle(value?.link?.is_child, key, lastParentIndices, parentAfterChildIndices)}
                                        tabIndex={getTabIndex(key)}
                                        data-ga-category={value?.link?.tracking_event_category || ''}
                                        data-ga-action={value?.link?.tracking_event_action || ''}
                                        data-ga-label={value?.link?.tracking_event_label || ''}
                                        onClick={(e) => {
                                            trackDepartmentPage(value?.link?.link?.title || 'LinkList');
                                            trackEvent({
                                                eventCategory: value?.link?.tracking_event_category || '',
                                                eventAction: value?.link?.tracking_event_action || '',
                                                eventLabel: value?.link?.tracking_event_label || '',
                                            });
                                            trackFeatureClickEvent(value?.link);
                                            handleOnClick(e, value?.link?.link?.href, history);
                                        }}
                                    >
                                        {replaceSpecialChar(value?.link?.link?.title, true)}
                                    </div>
                                )}
                            </>
                        )}
                </>
            ))}
        </div>
    );
}

LinkListContainer.propTypes = {
    classes: object.isRequired,
    data: shape({
        links: shape({
            link: shape({
                add_icon: bool,
                is_child: bool,
                hide: bool,
                tracking_event_action: string,
                tracking_event_category: string,
                tracking_event_label: string,
                link: shape({
                    href: string,
                    title: string,
                }).isRequired,
            }),
        }),
        orientation: 'string',
        presentation: 'string',
        styles: array,
    }).isRequired,
    history: object,
    trackEvent: func.isRequired,
    callCustomTrackingEvent: func.isRequired,
    isBot: bool,
    uid: string,
    type: string,
    departmentPageHeroRedesign: bool,
};
LinkListContainer.defaultProps = {
    isBot: false,
    uid: false,
    history: {},
    type: '',
    departmentPageHeroRedesign: false,
};
const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
    callCustomTrackingEvent: bindActionCreators(emitCustomTrackingEvent, dispatch),
});

export default connect(
    null,
    mapDispatchToProps,
)(withStyles(styles)(withRouter(LinkListContainer)));
